import React from "react";

const ErrorNotification = ({
  errorMessage = " An error occurred while retrieving the data. Please refresh the page to try again.",
}) => {
  return <p class="text-danger">{errorMessage}</p>;
};

export default ErrorNotification;
